import React, { Component } from "react";
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Card, Form } from 'antd';
import { Link } from 'react-router-dom';
import { Collapse } from 'antd';
import lockr from 'lockr';
import Media from 'react-media';

import * as userActions from '../../actions/user'
import * as teamsActions from '../../actions/teams';
import { StoreState, UserState, MatchesState, Match, ApplicationState } from './../../types';
import { Button, Input, InputPassword, Checkbox, Team, Title, TitleType, FormItem, RegisterForm, Row, Col, Block, RaceCalendar } from './../../components';
import config from './../../config';
import { HomeStyle } from "./HomeStyles";
import { H2, PageStyle, H1, H3 } from "../../styles/global";
import { mediaQueries, sizes } from '../../styles/media-queries';
import moment from 'moment';
import Countdown from 'react-countdown-now';
import { Redirect } from "react-router";
import { notification } from 'antd';
import Login from "../Login/Login";

const { Panel } = Collapse;

export interface Props {
	user: UserState;
	match: any;
	matches: MatchesState;
	application: ApplicationState;
	onLogOut?: () => void;
	t: any;
}

export interface State {

}

const { Meta } = Card;

const WrappedRegisterForm = Form.create()(RegisterForm);

class Home extends Component<Props> {

	state = {
		
	}

	constructor(props: Props) {
		super(props);
	}

	render() {
		const deadlineDate = this.props.matches && this.props.matches.info && this.props.matches.info.deadlineDate;

		const momentDeadlineDate = deadlineDate ? moment(deadlineDate).valueOf() : moment().valueOf();
		const deadlineMatch = this.props.matches.data
			.find((match: Match) => !!(
				this.props.matches.info &&
				this.props.matches.info.deadlineWeek &&
				match.weekId === this.props.matches.info.deadlineWeek
			));
		const hasDeadlineWeek = this.props.matches && this.props.matches.info && this.props.matches.info.deadlineWeek;

		const deadlineRenderer = ({ days, hours, minutes, seconds }: any) => {
			return <H3 style={{ color: 'white' }}>
				{deadlineMatch ? deadlineMatch.feedUrl : ''} : {days}d {hours}u {minutes}m {seconds}sec
			</H3>;
		};

		const team = this.props.user && this.props.user.teams && this.props.user.teams[0];
		const redirectToMyTeams = this.props.match.path === '/' && this.props.user && this.props.user.authenticated;

		return (
			<HomeStyle>
				{redirectToMyTeams && team && <Redirect
					to={{ pathname: `/team/${team.id}` }}
				/>}

				<Row>
					<Col md={12} lg={12} sm={24} xs={24}>
						<Row className="onboarding">
							<Col lg={24}>
								<h2>{this.props.t('homePage.cta')}</h2>
								<p>{this.props.t('homePage.welcome')}</p>
								<h4 className="title">{this.props.t('homePage.onboardingStep1Title')}</h4>
								{this.props.t('homePage.onboardingStep1copy')}
							</Col>
							<Col lg={24}><img src='https://wakeu-fantasy.s3.amazonaws.com/files/1-team.png' /></Col>
						</Row>
						<Row className="onboarding">
							<Col lg={24}>
								<h4 className="title">{this.props.t('homePage.onboardingStep2Title')}</h4>
								{this.props.t('homePage.onboardingStep2copy')}
							</Col>
							<Col lg={24}><img src='https://wakeu-fantasy.s3.amazonaws.com/files/2-points.png' /></Col>
						</Row>
						<Row className="onboarding">
							<Col lg={24}>
								<h4 className="title">{this.props.t('homePage.onboardingStep3Title')}</h4>
								{this.props.t('homePage.onboardingStep3copy')}
							</Col>
							<Col lg={24}><img src='https://wakeu-fantasy.s3.amazonaws.com/files/3-leagues.png' /></Col>
						</Row>
					</Col>
					<Col md={12} lg={12} sm={24} xs={24}>
					{
						!this.props.user.authenticated ?
						<Row className="login">
							<Col md={24} lg={24} sm={24} xs={24}>
								<Login t={this.props.t} />
							</Col>
						</Row> : null
					}
					</Col>
				</Row>

			</HomeStyle>
		);
	}
}

export function mapDispatchToProps(dispatch: Dispatch<userActions.UserAction>) {
	return {
		onLogOut: () => dispatch(userActions.logOut()),
	}
}

export function mapStateToProps({ user, matches, application }: StoreState.All) {
	return {
		user,
		matches,
		application
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
